import React from 'react';
import { isEmpty } from 'lodash';
import { getSetting } from '@utils/helpers';
import k from '@gral/constants';
import { Tooltip } from '@components/Outputs';
import { Switch } from '@components/Inputs';
import CSVDownloader from './00-csvDownloader';
import { TextField, Chip } from '@mui/material';
import { Button, Icon, IconButton } from '@ts/storybook';
import { withTranslation } from 'react-i18next';

class Toolbar extends React.Component {
  state = {
    showDownloadModal: false,
  };

  render() {
    const { autoRefresh, refreshEnabled, onRefresh, onAutoRefresh } = this.props;
    const rtl = this.props.lng == 'ar';
    const customTableSettings = getSetting('componentSettings')?.[this.props.componentId];

    const quickFindColumns = customTableSettings?.quickFindColumns;

    return (
      <div style={_style(rtl).superheader} id="tableV3-toolbar">
        <span style={_style(rtl).title.block}>
          {this.props.withTitle && <TTypograghy variant="h6">{`${this.props.t(this.props.title)}`}</TTypograghy>}
          {/*           {this.props.infoDataGrid && this.props.withTitle && <IconButtonPopover infoContent={this.props.infoDataGrid} />}
           */}
          {this.props.fAllowCreate && this.props.editUrl && (
            <Tooltip placement="top" title={`${this.props.t('Add')} ${this.props.t(this.props.title)}`}>
              <IconButton onClick={this.props.onClickNew} disabled={!this.props.fAllowCreate || !this.props.editUrl}>
                <Icon icon={'addBox'} />
              </IconButton>
            </Tooltip>
          )}
          <IconButton onClick={onRefresh} disabled={!refreshEnabled} style={{ marginRight: '10px' }}>
            <Icon icon={'Refresh'} />
          </IconButton>
          <Switch
            checked={autoRefresh}
            disabled={!refreshEnabled}
            onChange={onAutoRefresh}
            leftLabel={this.props.t('Auto refresh')}
            tooltip={this.props.t('60 seconds')}
          />
        </span>
        <span style={_style(rtl).tools.block}>
          {quickFindColumns && (
            <TextField
              variant="standard"
              onChange={this.props.onChangeQuickfind}
              value={this.props.quickfindWord}
              placeholder={`${this.props.t('Filter this page')}`}
              style={_style(rtl).tools.searchInput}
              onKeyPress={ev => {
                if (ev.key === 'Enter') {
                  this.props.onQuickfindButtonClick();
                  ev.preventDefault();
                }
              }}
            />
          )}
          {!isEmpty(this.props.quickfindWord) && (
            <Tooltip placement="top" title={`${this.props.t('Clear all filters')}`}>
              <span>
                <IconButton onClick={this.props.onClearFilters} disabled={!this.props.fAllowClearFilters}>
                  <Icon icon={'content-clear'} />
                </IconButton>
              </span>
            </Tooltip>
          )}
          {this.props.fAllowSearch && !isEmpty(this.props.quickfindWord) && (
            <Button variant="outlined" onClick={this.props.onQuickfindButtonClick} label="Search" />
          )}
          {this.props.fAllowAdvancedSearch && this.props.onAdvancedSearchClick && (
            <Tooltip placement="top" title={`${this.props.t('Advanced search')}`}>
              <span>
                <IconButton disabled={!this.props.fAllowAdvancedSearch} onClick={this.props.onAdvancedSearchClick}>
                  <Icon icon="action-search" />
                </IconButton>
              </span>
            </Tooltip>
          )}
          <Tooltip placement="top" title={`${this.props.t('Configuration')}`}>
            <span>
              <IconButton onClick={this.props.onTableSettingsClick}>
                <Icon icon="action-settings" />
              </IconButton>
            </span>
          </Tooltip>
          {this.props.downloadOptions && (
            <>
              <span
                style={{
                  borderLeft: '1px solid gray',
                }}
              />
              <CSVDownloader {...this.props} />
            </>
          )}
        </span>
        <div style={{ clear: 'both' }} />
        {this.renderFilterDesc()}
      </div>
    );
  }

  renderFilterDesc() {
    let advancedSearch = this.props.advancedSearch;
    if (!this.props.showFilterDesc || !advancedSearch.count()) return;
    let chips = [];

    advancedSearch.forEach((item, key) => {
      const descriptor = item.getIn(['filter', 'desc']);
      let value = item.getIn(['filter', 'fnValue'])(item);
      if (value || value === false) value = `: ${value}`;
      chips.push(
        <Chip
          key={key}
          label={`${descriptor}${value}`}
          onDelete={this.props.lockAdvancedSearch ? undefined : this.props.onDeleteFilter(key)}
          className="mx-1"
        />
      );
    });
    return <div className="mb-2">{chips}</div>;
  }
  // end class
}

let _style = rtl => ({
  superheader: {
    borderBottom: `2px solid ${k.gui.colors.lighterGray}`,
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'hidden',
    lineHeight: '36px',
    // paddingLeft: 24,
    paddingRight: 8,
    paddingLeft: '10px',
    boxSizing: 'border-box',
    flexGrow: 1,
  },
  title: {
    block: {
      float: rtl ? 'right' : 'left',
      marginTop: 10,
      display: 'flex',
      alignItems: 'center',
      // maxWidth: "50%"
    },
    titleSubtitle: {
      fontSize: 20,
      textOverflow: 'ellipsis',
      marginRight: '15px',
    },
    subtitle: {
      paddingLeft: 5,
      color: k.gui.colors.mediumGray,
      marginRight: 8,
    },
  },
  tools: {
    block: {
      marginTop: 8,
      float: rtl ? 'left' : 'right',
      whiteSpace: 'nowrap',
    },
    searchInput: {
      width: '150px',
      top: '5px',
      marginRight: '10px',
    },
  },
});

export default withTranslation()(Toolbar);
